

export const heroData = {
  subheading: "HI, I AM DIYA J CYRIAC",
  headlineBold: "I'm a front-end developer and UI/UX designer ",
  headlineLight: "that creates high-performing and user-friendly websites.",
  primaryCTA: "Let's Connect",
  primaryCTAHref: '#contact',
  secondaryCTA: "See My Experience",
  secondaryCTAHref: '#experience',
};














